<template>
  <div class="animated fadeIn">
    <div>
      <b-row v-if="loading">
        <b-col md="6">
          <atom-spinner
            :animation-duration="1000"
            :size="60"
            color="#ff1d5e"
            class="float-right my-4"
          />
        </b-col>
      </b-row>
    </div>
    <div v-if="!loading" class="mt-1">
      <b-row
        ><b-col md="9"><h3>Customer Report</h3></b-col>
        <b-col
          ><b-button
            variant="primary"
            class="ml-5"
            @click="
              $router.push({ name: 'history', params: { type: 'CUSTOMER' } })
            "
            >View Download History</b-button
          ></b-col
        ></b-row
      >
      <b-row>
        <b-col md="8">
          <h4>Customer Registration Report</h4>
        </b-col>
        <b-col md="1">
          <img
            src="@/assets/images/DataExport.png"
            class="upload-btn ml-4"
            alt="data export"
            @click="createRequest"
          />
        </b-col>
        <b-col md="3">
          <eb-select
            style="background-color: #fff"
            id="text"
            type="text"
            label="text"
            :options="dateOption"
            v-model="selectedDate"
            :selected="selectedDate.text"
            @input="changeDate"
          >
          </eb-select>
          <c-date
              ref="compRefs"
              modalRef="modalRef"
              modalId="dateModal"
              @customDateRange="findDateResult"
            ></c-date>
        </b-col>
      </b-row>
      <div
        v-if="
          this.$currentUserData.category == 'TA' ||
          this.$currentUserData.category == 'DISTRIBUTOR' ||
          this.$currentUserData.category == 'DEALER' ||
          this.$currentUserData.category == 'SELLER' ||
          $userRole == 'Tenant' ||
          $userRole == 'Admin'
        "
      >
        <BarChart value="daily-registration" :chart-data="chartData" />
      </div>
      <div v-else>
        <h4 class="text-center my-5">No Data Available</h4>
      </div>
    </div>
  </div>
</template>
<script>
import ebSelect from "@/components/FormElements/Select.vue";
import BarChart from "@/components/chart/BarChart";
import moment from "moment";
import dailyRegistrationChartData from "@/utils/dailyRegistrationChartData";
import cDate from "@/components/FormElements/CustomDate.vue";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "Reports",
  components: {
    BarChart,
    ebSelect,
    cDate,
    AtomSpinner,
  },
  data() {
    return {
      loading: false,
      chartOptions: {
        hoverBorderWidth: 10,
      },
      selectedDate: {
        text: "Today",
        value: 1,
      },
      dateOption: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 day's",
          value: 7,
        },
        {
          text: "30 day's",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      startDate: "",
      endDate: "",
    };
  },
  computed: {
    userId() {
      if (this.$store.getters["auth/getUserID"]) {
        return this.$store.getters["auth/getUserID"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
      }
    },
    chartData() {
      let data = this.$store.getters["partner/GetBulkAnalyticsRept"];
      let dailyRegistrationKey = "";
      let registrationCount = "";
      let dayCount = "";
      if (this.$currentUserData.category == "TA") {
        dailyRegistrationKey = "daily-registration-graph";
        registrationCount = "count";
        dayCount = "day";
      } else if (this.$currentUserData.category === "SELLER") {
        dailyRegistrationKey = "seller-daily-registration-graph";
        registrationCount = "count";
        dayCount = "day";
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        dailyRegistrationKey = "subdealer-daily-registration-graph";
        registrationCount = "count";
        dayCount = "day";
      }
      const dailyRegistration = data[dailyRegistrationKey];
      return dailyRegistrationChartData(
        dailyRegistration,
        registrationCount,
        dayCount
      );
    },
  },
  methods: {
    findDateResult(e) {
      this.startDate = e.fromDate,
      this.endDate = e.toDate,
      
      this.getAnalyticsData();
    },
    changeDate(e) {
      this.selectedDate = e;
      if (e.value == "custom") {
        this.$refs["compRefs"].openModal();
        return;
      }
      this.getAnalyticsData();
    },
    async getAnalyticsData() {
      if (this.$currentUserData.category === "TA") {
        const payload = {
          items: [
            {
              key: "daily-registration-graph",
              variables: {
                ...this.getDateData(this.selectedDate.value),
                tenant: this.userId,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchBulkAnalyticReport", payload);
      } else if (this.$currentUserData.category === "SELLER") {
        const payload = {
          items: [
            {
              key: "seller-daily-registration-graph",
              variables: {
                ...this.getDateData(this.selectedDate.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchBulkAnalyticReport", payload);
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        const payload = {
          items: [
            {
              key: "subdealer-daily-registration-graph",
              variables: {
                ...this.getDateData(this.selectedDate.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchBulkAnalyticReport", payload);
      }
    },
    getDateData(dateData) {
      if (dateData == "custom") {
        const data = {
          fromDate: this.startDate,
          toDate: this.endDate,
        };
        return data;
      }
      if (dateData == 1) {
        const data = {
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        return data;
      } else {
        const data = {
          fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        if (typeof dateData === "number") {
          data.fromDate = moment()
            .subtract(dateData - 1, "days")
            .format("YYYY-MM-DD");
          return data;
        } else if (typeof dateData === "object") {
          return dateData;
        }
        return data;
      }
    },
    createRequest() {
      const payload = {
        filterBy: {
          ...this.getDateData(this.selectedDate.value),
          collectionName: "CUSTOMER",
        },
        requestBy: {
          _id: this.$currentUserData._id,
          name: this.$currentUserData.userName,
          email: this.$currentUserData.email,
          phone: this.$currentUserData.phone,
        },
      };
      this.$store
        .dispatch("partner/createRequestDownload", payload)
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Request successful!!",
            type: "success",
          });
        })
        .catch((error) =>
          this.$toasted.error(
            error.message ? error.message : "Error Request could not completed"
          )
        );
    },
  },

  mounted() {
    this.getAnalyticsData();
  },
};
</script>
<style scoped>
.upload-btn {
  height: 39px;
}
</style>